// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {transactionAddItem,transactionGetItem,TRANSACTION_USER_ID} from '../../actions/transactionActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/transaction/TransactionAddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {list as userList} from '../../containers/user/ListPage';
import {getItem as userInfo} from '../../containers/user/AddEditFormPage';
import {reset} from "redux-form";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.product.getItem,
        userValue: state.app.currentUser,
        userList: state.user.list,
        userInfo : state.user.getItem,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getUserList: () => {
        return(dispatch(userList()))
    },
    getUserInfo: (userId) => {
        return(dispatch({type: TRANSACTION_USER_ID, data: userId}))

    },
    getTechnicianInfo: (id) => {
        return(dispatch(userInfo(id)))
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {

    return (dispatch, getState) => {
        const states = getState();
        let userId = '';

        if(states.transaction.transactionUserId)
            userId = states.transaction.transactionUserId


        var formData = {
            'benefetiary'  : userId,
            'trx_type'     : values.trx_type,
            'description'  : values.description,
            'amount'       : parseInt(values.amount)
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('transaction', formData).then(res => {
            dispatch(transactionAddItem(res.data.lists));
            if(res.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                dispatch(reset('addTransaction'));
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
